<script>
    import { onMount } from "svelte";
    import { Router, Route, Link } from "svelte-navigator";
    import baseUrl from "../../config/config";

    let addCategoryLoading = false;

    let category;

    let slug;

    let parent;

    let categories = [];

    onMount(() => {
        getCategories();
    });

    const clearForm = () => {
        let form = document.getElementById("addCategoryForm");
        form.reset();
    };
    const getCategories = () => {
        // get the catgories
        fetch(baseUrl + "get-categories.php")
            .then((res) => res.json())
            .then((data) => {
                // console.log(data);
                categories = data;
            })
            .catch((e) => {
                console.log(e);
            });
    };
    const handleAddCategory = () => {
        let cat = {
            category: category,
            slug: slug,
            parent: parent,
        };

        addCategoryLoading = true;

        fetch(baseUrl + "add-category.php", {
            method: "POST",
            body: JSON.stringify(cat),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                // console.log(data);

                getCategories();
                clearForm();

                addCategoryLoading = false;
            })
            .catch((e) => {
                console.log(e);
                addCategoryLoading = false;
            });
    };

    const editCategory = (catId) => {
        console.log(catId);
    };

    const deleteCategory = (catId) => {
        console.log(catId);
    };
</script>

<main>
    <Router primary={false}>
        <div class="mainContainer">
            <div class="leftCol">
                <form
                    id="addCategoryForm"
                    class="ui form"
                    on:submit|preventDefault={handleAddCategory}
                >
                    <div class="field">
                        <label for="category"> Category Name </label>

                        <input
                            type="text"
                            name="category"
                            id="category"
                            required
                            placeholder="Category"
                            bind:value={category}
                        />

                        <div class="" style="font-size: 12px;">
                            <i>The name is how it appears on your site.</i>
                        </div>
                    </div>

                    <div class="field">
                        <label for="category"> Slug </label>

                        <input
                            type="text"
                            name="slug"
                            id="slug"
                            required
                            bind:value={slug}
                            placeholder="slug"
                        />

                        <div class="" style="font-size: 12px;">
                            <i
                                >The “slug” is the URL-friendly version of the
                                name. It is usually all lowercase and contains
                                only letters, numbers, and hyphens.</i
                            >
                        </div>
                    </div>

                    <div class="field">
                        <label for="Parent Category">Parent Category</label>
                        <select name="parent" id="parent" bind:value={parent}>
                            <option value="">Select Parent Category</option>
                            {#each categories as category}
                                <option value={category.name}
                                    >{category.name}</option
                                >
                            {/each}
                        </select>
                    </div>

                    <div
                        class="field"
                        style="padding-top: 2em;text-align:center;"
                    >
                        {#if addCategoryLoading}
                            <button class="ui purple basic loading button">
                                <i class="plus icon" /> Add
                            </button>
                        {:else}
                            <button class="ui purple basic button">
                                <i class="plus icon" /> Add
                            </button>
                        {/if}
                    </div>
                </form>
            </div>
            <div style="max-height: 50em;overflow:auto;" class="mainCol">
                <table class="ui striped basic inverted unstackable table">
                    <thead>
                        <tr>
                            <th> No </th>
                            <th> Name </th>
                            <th> Parent </th>
                            <th> Slug </th>
                            <th>Products</th>
                        </tr>
                    </thead>
                    <tbody >
                        {#each categories as category}
                            <tr>
                                <td>
                                    {category.no}
                                </td>
                                <td style="font-weight: 600;">
                                    {category.name} <br />
                                    <div
                                        class=""
                                        style="font-weight: 100;font-size:12px;"
                                    >
                                        <span
                                            on:click={() => {
                                                deleteCategory(category.id);
                                            }}
                                            style="color:yellow;cursor:pointer;"
                                            ><i class=" edit icon" />Edit
                                        </span>
                                        &nbsp;&nbsp;
                                        <span
                                            on:click={() => {
                                                deleteCategory(category.id);
                                            }}
                                            style="color:red;cursor:pointer;"
                                            ><i class=" delete icon" />Delete
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    {category.parent}
                                </td>
                                <td>
                                    {category.slug}
                                </td>
                                <td>
                                    {category.products}
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </Router>
</main>

<style>
    .mainContainer {
        display: flex;
        flex-direction: column;
    }

    label {
        color: aliceblue !important;
        font-weight: 100 !important;
    }

    input {
        background: #272727 !important;
        color: aliceblue !important;
    }

    select {
        background: #272727 !important;
        color: aliceblue !important;
    }
    .leftCol {
        flex: 2;
        padding: 1em;
        border-right: 1px solid rgba(128, 128, 128, 0.705);
    }

    .mainCol {
        flex: 5;
        padding: 1em;
    }
    @media only screen and (min-width: 768px) {
        .mainContainer {
            display: flex;
            flex-direction: row;
        }
    }
</style>
